import { analytics } from "../../firebase-config";
import { logEvent } from "firebase/analytics";
import ReactGA from "react-ga4";

//  Firebase tracking
export const logReferrer = () => {
  if (analytics && typeof window !== "undefined" && window.referrerURL) {
    // console.log("inside logReferrer - window.referrerURL", window);
    logEvent(analytics, "referrer", {
      referrer_url: window.referrerURL,
    });
  }
};

export const logAnalyticsEvent = (eventName, params) => {
  if (analytics) {
    logEvent(analytics, eventName, params);
  }
};

//  GA tracking
export const logGAPageView = (eventName, params) => {
  console.log("inside logGAPageView:", eventName, params);
  ReactGA.send({
    hitType: eventName,
    page_path: params.page_path,
    page_params: params.page_params,
  });
};

// GTAG tracking
export const trackGtagEvent = (eventName, params = {}) => {
  if (typeof window !== "undefined") {
    if (window.gtag) {
      window.gtag("event", eventName, {
        event_category: params.event_category,
        event_label: params.event_label,
        value: params.value,
      });
    } else {
      console.debug("Gtag not found", { eventName, params });
    }
  }
};

// App download intent conversion 
export const trackGoogleAdsAppDownloadIntent = (callback) => {
  const sendToId = "AW-17034300624/_TFsCObuqL4aENCZy7o_";

  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "conversion", {
      send_to: sendToId,
      event_callback: callback,
    });
  } else {
    console.debug("Gtag not found for conversion", { sendToId });
    if (callback) callback(); // fallback
  }
};

// Facebook Pixel tracking
export const trackPixel = (eventName, params = {}) => {
  if (typeof window !== "undefined") {
    if (window.fbq) {
      window.fbq("track", eventName, params);
    } else {
      console.debug("trackPixel(): fbq not found", { eventName, params });
    }
  }
};
